import { NavigateFunction } from 'react-router'
import FFGFormNavigation from './FFGFormNavigation'
import SmavaFormNavigation from 'components/Smava/FormNavigation'
import FormNavigationEditPage from 'components/RceEdit/FormNavigtionEditPage'
import { useStores } from 'stores/utils/hooks/useStores'
import { observer } from 'mobx-react'
import { RCE_EDIT_PAGE_NAMES } from 'utils/pages'
import { PageText } from 'components/RceEdit/RCEEdit'

interface Props {
  isSmava?: boolean
  onBack?: () => void
  onNext: () => void
  navigate: NavigateFunction
  isOfferLabel?: boolean
}

const FormNavigationSwitcher = observer((props: Props) => {
  const sharedProps = {
    onNext: props.onNext,
    onBack: props.onBack,
    navigate: props.navigate
  }

  const {
    page: { config },
    navigation: { currentPageInSession }
  } = useStores()

  const { isSmava, isOfferLabel } = props
  const isRCEEditPage =
    config.separateEditPage &&
    RCE_EDIT_PAGE_NAMES.includes(currentPageInSession || '')

  if (isRCEEditPage && currentPageInSession) {
    // @ts-ignore - PageText type needs refinement for dynamic access
    const continueButtonText = PageText[currentPageInSession]

    return (
      <FormNavigationEditPage
        {...sharedProps}
        continueButtonText={continueButtonText}
        isSmava={!!isSmava}
      />
    )
  }

  if (isSmava) {
    return (
      <SmavaFormNavigation
        {...sharedProps}
        legalContact="info@smava.de"
        isOfferLabel={isOfferLabel}
      />
    )
  }

  return (
    <FFGFormNavigation {...sharedProps} legalContact="kredite@finanzcheck.de" />
  )
})

export { FormNavigationSwitcher }
